// extracted by mini-css-extract-plugin
export default {"card":"PackTableColumns_card__dMv5V","blueButton":"PackTableColumns_blueButton__tpnct","orangeButton":"PackTableColumns_orangeButton__61gMh"};